export const BASE_URL = "https://api.lisaconnect.itinnove.io/";
export const ASSETS_URL = "https://assets.lisaconnect.itinnove.io";
